import locales from '../../content.json';

function addDay(n, hoursShow = true) {
  let months = [
    locales[window.userLang].payment_text_69,
    locales[window.userLang].payment_text_70,
    locales[window.userLang].payment_text_71,
    locales[window.userLang].payment_text_72,
    locales[window.userLang].payment_text_73,
    locales[window.userLang].payment_text_74,
    locales[window.userLang].payment_text_75,
    locales[window.userLang].payment_text_76,
    locales[window.userLang].payment_text_77,
    locales[window.userLang].payment_text_78,
    locales[window.userLang].payment_text_79,
    locales[window.userLang].payment_text_80,
  ];
  const monthsRU = [
    'Января', 'Февраля', 'Марта', 'Апреля', 'Мая', 'Июня', 'Июля', 'Августа', 'Сентября', 'Октября', 'Ноября', 'Декабря',
  ];
  const { lang } = document.documentElement;
  let dt = new Date();
  dt.setDate(dt.getDate() + n);
  let mont = dt.getMonth();
  let day = dt.getDate();
  let year = dt.getFullYear();
  let hours = dt.getHours();
  let min = dt.getMinutes();
  let strMin;
  let strHours;
  if (min < 10) {
    strMin = "0" + min;
  } else {
    strMin = min;
  }
  if (hours > 12) {
    hours = hours - 2;
    strHours = hours.toString().slice(1) + ":" + strMin + " " + "PM";
  } else {
    strHours = hours + ":" + strMin + " " + "AM";
  }
  let strDt;
  if(!hoursShow) {
    if(lang === 'ru') {
      strDt = `${day} ${monthsRU[mont]} ${year}`;
    } else {
      strDt = `${months[mont]} ${day}, ${year}`;
    }
  } else {
    strDt = `${months[mont]} ${day}, ${year}, ${strHours}`;
  }
  return strDt;
}

export const getDay = (product) => {
  let duration = product.details.duration;
  if (duration) {
    let periodTextValue = duration.unit;
    let day = addDay(7);
    if (periodTextValue === "month" && duration.value === 6) {
      day = addDay(182);
    }
    if (
      periodTextValue === "month" &&
      duration.value > 1 &&
      duration.value < 6
    ) {
      day = addDay(90);
    }
    if (periodTextValue === "month" && duration.value === 1) {
      day = addDay(30);
    }
    if (periodTextValue === "year" && duration.value === 1) {
      day = addDay(365);
    }
    return day;
  }
}

export const getIntroDay = (product) => {
  let duration = product.duration;
  if (duration) {
    let periodTextValue = duration.trial_period_unit;
    let day = addDay(duration.trial_period_value, false);
    if (periodTextValue === "month" && duration.trial_period_value === 6) {
      day = addDay(182, false);
    }
    if (
      periodTextValue === "month" &&
      duration.trial_period_value > 1 &&
      duration.trial_period_value < 6
    ) {
      day = addDay(90, false);
    }
    if (periodTextValue === "month" && duration.trial_period_value === 1) {
      day = addDay(30, false);
    }
    if (periodTextValue === "year" && duration.trial_period_value === 1) {
      day = addDay(365, false);
    }
    if (periodTextValue === "week" && duration.trial_period_value === 1) {
      day = addDay(7, false);
    }
    return day;
  }
}